import React, { useEffect, useRef, useState } from 'react';
import './AddEventCard.css';
import BodySmallRegular from '../designSystem/BodySmallRegular';
import clockIcon from "../../assets/images/clockIcon.svg";
import practiceLocationIcon from "../../assets/images/Icon=Practice Locations.svg";
import cityIcon from "../../assets/images/Icon=City.svg";
import doctorIcon from "../../assets/images/Icon=Doctors.svg";
import CustomTimeSelect from './CustomTimeSelect';
import minusIcon from "../../assets/images/minusIcon.svg";
import CustomSelect from './CustomSelect';
import { useDispatch, useSelector } from 'react-redux';
import { getDoctorsByPracticeLocation } from '../../actions/userActions/doctorAction';
import BodyExtraSmallRegular from '../designSystem/BodyExtraSmallRegular';
import { getTaskPracticeLocations } from '../../actions/userActions/tasks/taskAction';
import MultiSelect from '../designSystem/MultiSelect';import SingleSelect from '../designSystem/SingleSelect';
import BodySmallMedium from '../designSystem/BodySmallMedium';
import BodyMediumMedium from '../designSystem/BodyMediumMedium';
import { t } from '../../locales/translate';
const AddEventCard = ({ isDeleteActive, planDetail, onUpdatePlanDetail, practiceLocations, index, isVisitProfileId, errors, formValues, activeVisitProfileId, isChecked, onToggleCheckbox, isOnLeave, isPracticeLocationsLoading, taskLookups, taskLookupsLoading }) => {        const permissions = JSON.parse(localStorage.getItem('permissionsList'));
        const user = JSON.parse(localStorage.getItem("user")); 

    const [doctorsList, setDoctorsList] = useState([]);
    const [isDoctorsLoading, setIsDoctorsLoading] = useState(false);
    const [locationsList, setLocationsList] = useState([]);
    const [visitProfileData, setVisitProfileData] = useState(null);
    const [cityDisabled, setCityDisabled] = useState(false);
    const originallySelectedProductIdsRef = useRef(
        (planDetail.products || []).map((id) => String(id))
    );
    const originallySelectedSubTaskIdsRef = useRef(
        (planDetail.subTasks || []).map((id) => String(id))
    );
    const originallySelectedPriorityRef = useRef(
        planDetail.priority === null || planDetail.priority === undefined || planDetail.priority === ""
            ? []
            : [String(planDetail.priority)]
    );
    const dispatch = useDispatch();
    const visitProfileDetail = useSelector(state => state.visitProfile_reducer.visitProfileDetail);
    const fetchedDoctors = useSelector((state) => state.doctors_reducer.getDoctors);
    const cities = useSelector((state) => state.cities_reducer.cities);
    const HOURS_IN_DAY = 24;
    const MINUTES_IN_HOUR = 60;
    const MINUTE_INCREMENT = 15;
    const PADDING_CHAR = '0';
    const MIN_PADDING_LENGTH = 2;
    const AM = 'AM';
    const PM = 'PM';
    const HOUR_DIVISOR = 12;
    const DEFAULT_HOUR = 12;
    const LAST_HOUR = 23;
    const LAST_MINUTE = 59;
    const SECONDS = '00';
    useEffect(() => {
    if (!isVisitProfileId && planDetail.practiceLocationId && permissions && permissions.includes('CanAddPlannerDoctor')) {
        setIsDoctorsLoading(true);
        const doctorBody = {
            practiceLocationId: planDetail.practiceLocationId,
            pageNumber: -1,
            pageSize: 0,
            textSearch: "",
        };
        dispatch(getDoctorsByPracticeLocation(doctorBody));
    }
}, [planDetail.practiceLocationId]);

    const handleLocationChange = (e) => {
        const newPracticeLocationId = parseInt(e.target.value);

        onUpdatePlanDetail(index, { practiceLocationId: newPracticeLocationId, doctorId: null });
    };
    const handleDoctorChange = (e) => {
        const newDoctorId = parseInt(e.target.value);
        onUpdatePlanDetail(index, { doctorId: newDoctorId });
    };
    // const handleCityChange = (e) => {
    //     const newCityId = parseInt(e.target.value);
    //     onUpdatePlanDetail(index, { cityId: newCityId, practiceLocationId: null });
    // };
    const handleCitySelect = (event) => {
        const selectedCityId = event.target.value;
        if (selectedCityId === "clear") {
            onUpdatePlanDetail(index, { cityId: null, practiceLocationId: null });
        } else {
            const selectedCityId = parseInt(event.target.value);
            onUpdatePlanDetail(index, { cityId: selectedCityId, practiceLocationId: null });
        }
    };

    useEffect(() => {
    if (fetchedDoctors && Array.isArray(fetchedDoctors) && fetchedDoctors.length > 0) {
        setDoctorsList((prevDoctorsList) => {
            const updatedList = [...prevDoctorsList];

            fetchedDoctors.forEach((newLocation) => {
                const existingLocation = updatedList.find(
                    (loc) => loc.practiceLocationId === newLocation.practiceLocationId
                );

                if (existingLocation) {
                    existingLocation.doctors = [
                        ...new Map(
                            [...(existingLocation?.doctors || []), ...(newLocation.doctors || [])].map((doctor) => [
                                doctor.id,
                                doctor,
                            ])
                        ).values(),
                    ];
                } else {
                    updatedList.push(newLocation);
                }
            });

            return updatedList;
        });
        setIsDoctorsLoading(false);
    } else if (fetchedDoctors === null || (Array.isArray(fetchedDoctors) && fetchedDoctors.length === 0)) {
        setIsDoctorsLoading(false);
    }
}, [fetchedDoctors]);
    const generateTimeOptions = () => {
        const times = [];

        for (let hour = 0; hour < HOURS_IN_DAY; hour++) {
            for (let minute = 0; minute < MINUTES_IN_HOUR; minute += MINUTE_INCREMENT) {
                const rawValue = `${hour.toString().padStart(MIN_PADDING_LENGTH, PADDING_CHAR)}:${minute.toString().padStart(MIN_PADDING_LENGTH, PADDING_CHAR)}:${SECONDS}`;
                const ampm = hour >= HOUR_DIVISOR ? PM : AM;
                const displayHour = hour % HOUR_DIVISOR || DEFAULT_HOUR;
                const label = `${displayHour.toString().padStart(MIN_PADDING_LENGTH, PADDING_CHAR)}:${minute.toString().padStart(MIN_PADDING_LENGTH, PADDING_CHAR)} ${ampm}`;
                times.push({ value: rawValue, label });
            }
        }
        times.push({ value: `${LAST_HOUR}:${LAST_MINUTE}:${SECONDS}`, label: `11:${LAST_MINUTE} ${PM}` });

        return times;
    };



    const timeOptions = generateTimeOptions();
    const filteredStartTimeOptions = () => {
        return timeOptions.filter((time) => {
            const [hour, minute] = time.value.split(':').map(Number);
            return hour < 23 || (hour === 23 && minute <= 30); // Exclude times after 11:30 PM
        });
    };
    const filteredEndTimeOptions = () => {
        if (!planDetail.startTime) return timeOptions;

        const startTimeParts = planDetail?.startTime?.split(':');
        const startHour = parseInt(startTimeParts[0], 10);
        const startMinute = parseInt(startTimeParts[1], 10);
        const startTimeInMinutes = startHour * 60 + startMinute;

        // Filter to include only times after the start time, ensuring no rounding issues
        return timeOptions.filter((time) => {
            const timeParts = time.value.split(':');
            const timeHour = parseInt(timeParts[0], 10);
            const timeMinute = parseInt(timeParts[1], 10);
            const timeInMinutes = timeHour * 60 + timeMinute;

            // Ensure no times after 11:59 PM are included
            return (timeInMinutes > startTimeInMinutes && timeInMinutes <= 1439) ||
                (timeHour === 23 && timeMinute === 59);
        });
    };

    const handleFromTimeSelect = (e) => {
        const fromTime = e.target.value;

        if (e.target.isManualEntry) {
            onUpdatePlanDetail(index, { startTime: fromTime, endTime: null });
        } else {
            onUpdatePlanDetail(index, { startTime: fromTime, endTime: null });
        }
    };

    const handleToTimeSelect = (e) => {
        const toTime = e.target.value;
        if (e.target.isManualEntry) {
            onUpdatePlanDetail(index, { endTime: toTime });
        } else {
            onUpdatePlanDetail(index, { endTime: toTime });
        }
    };
    const handleHeadOfficeChange = (e) => {
        const isHeadOfficeChecked = e.target.checked;
        onUpdatePlanDetail(index, { headOffice: isHeadOfficeChecked });
        if (isHeadOfficeChecked) {
            onUpdatePlanDetail(index, { cityId: null, practiceLocationId: null });
            setCityDisabled(true);
        } else {
            setCityDisabled(false);
        }
    };
    const handleCheckbox = (e) => {
        onToggleCheckbox(index, e.target.checked);
    };

    // NEW CODE
useEffect(() => {
    if (isVisitProfileId && visitProfileDetail && visitProfileDetail !== "isLoading" && visitProfileDetail.result && visitProfileDetail.result.length !== 0) {
        setVisitProfileData(visitProfileDetail.result[0]);
    } else if (!isVisitProfileId) {
        setVisitProfileData(null); // Clear when not using visit profile
    }
}, [visitProfileDetail, isVisitProfileId]);

    useEffect(() => {
    if (permissions && permissions.includes('CanAddPlannerCity') && permissions.includes('CanAddPlannerLocation') && planDetail.cityId && planDetail.cityId !== "clear") {
        dispatch(getTaskPracticeLocations(planDetail.cityId));
    }
}, [planDetail.cityId]);

    useEffect(() => {
        if (
            practiceLocations &&
            practiceLocations !== "isLoading" &&
            practiceLocations.length > 0 &&
            practiceLocations
        ) {
            const firstPracticeLocation = practiceLocations[0];
            const cityId = firstPracticeLocation.city; // Assuming `city` is the `cityId`

            setLocationsList((prevLocationsList) => {
                const updatedList = [...prevLocationsList];
                const existingEntryIndex = updatedList.findIndex(
                    (location) => location.cityId === cityId
                );

                if (existingEntryIndex !== -1) {
                    // Update existing entry
                    const existingEntry = updatedList[existingEntryIndex];
                    existingEntry.practiceLocations = [
                        ...new Map(
                            [
                                ...existingEntry.practiceLocations,
                                ...practiceLocations,
                            ].map((loc) => [loc.id, loc])
                        ).values(),
                    ];
                    updatedList[existingEntryIndex] = { ...existingEntry }; // Ensure immutability
                } else {
                    // Add a new entry
                    updatedList.push({
                        cityId,
                        practiceLocations: practiceLocations,
                    });
                }

                return updatedList;
            });
        }
    }, [practiceLocations]);
// NEW CODE
const getCityOptions = () => {
    const user = JSON.parse(localStorage.getItem("user"));
    const userCityId = user?.result[0]?.user?.cityId;
    const userCityName = user?.result[0]?.user?.cityName;
    let cityOptions = [];
    
    // For visit profile: show the visit profile's city
    if (isVisitProfileId && visitProfileData) {
        const visitProfileCityId = visitProfileData.cityId;
        const visitProfileCityName = visitProfileData.cityName;
        if (visitProfileCityId && visitProfileCityName) {
            cityOptions.push({
                value: visitProfileCityId,
                label: visitProfileCityName
            });
        }
        return cityOptions;
    }
    
    if (formValues.employeePlanId && formValues.employeePlanId !== 0 && 
        permissions && permissions.includes('CanAddPlannerCity') && 
        !permissions.includes('CanAddPlannerTime')) {
        cityOptions.push({ value: "clear", label: "None" });
        cityOptions.push({ value: "divider", label: "──────────────", disabled: true });
    }
    
    
    if (cities && cities !== "isLoading" && cities?.result && cities?.result.length !== 0) {
        cities?.result.forEach(city => {
            cityOptions.push({
                value: city.id,
                label: city.name
            });
        });
    } else if (userCityId) {
        if (practiceLocations && practiceLocations !== "isLoading" && 
            Array.isArray(practiceLocations) && practiceLocations.length > 0) {
            const cityName = practiceLocations[0]?.cityName;
            if (cityName) {
                cityOptions.push({
                    value: userCityId,
                    label: cityName
                });
            }
        } else if (userCityName) {
            cityOptions.push({
                value: userCityId,
                label: userCityName
            });
        }
    }
    
    return cityOptions;
};
const getLocationOptions = () => {
    let locationOptions = [];
    
    if (isPracticeLocationsLoading) {
        return [{ value: "loading", label: "Loading...", disabled: true }];
    }
    
    if (
        permissions && 
        !permissions.includes('CanAddPlannerCity') && 
        permissions.includes('CanAddPlannerLocation') && 
        !isVisitProfileId && 
        practiceLocations && 
        practiceLocations !== "isLoading" && 
        practiceLocations.length !== 0 && 
        practiceLocations
    ) {
        if (Array.isArray(practiceLocations) && practiceLocations.length > 0) {
    practiceLocations.forEach(location => {
        locationOptions.push({
            value: location.id,
            label: location.name,
            subtext: location.typeName && location.address
                ? `${location.typeName} - ${location.address}`
                : (location.typeName || location.address || "")
        });
    });
}

    return locationOptions;
};
        // Add visit profile locations if applicable
        if (isVisitProfileId && visitProfileData && visitProfileData.visitLocations?.length > 0) {
            visitProfileData.visitLocations.forEach(location => {
                locationOptions.push({
                    value: location.practiceLocation.id,
                    label: location.practiceLocation.name,
                    subtext: location.practiceLocation.typeName && location.practiceLocation.address ?
                    `${location.practiceLocation.typeName} - ${location.practiceLocation.address}` :
                    (location.practiceLocation.typeName || location.practiceLocation.address || "")
                });
            });
        }
        
        // Add city-filtered locations if applicable
        if (permissions && permissions.includes("CanAddPlannerCity") && 
            permissions.includes("CanAddPlannerLocation") && !isVisitProfileId && 
            locationsList && locationsList.length !== 0 && 
            locationsList.filter((locationGroup) => locationGroup.cityId === planDetail.cityId).length > 0) {
            
            const cityLocations = locationsList
                .filter((locationGroup) => locationGroup.cityId === planDetail.cityId)
                .flatMap((locationGroup) => {
                    if (locationGroup.practiceLocations.length === 0) {
                        return [{ value: "no-data", label: "No data", disabled: true }];
                    }

                    const availableLocations = locationGroup.practiceLocations
                        .filter((location) => {
                            const activePlanDate = formValues.employeePlanDates.find(pd => pd.visitProfileId === activeVisitProfileId);
const isLocationSelected = activePlanDate?.planDetails.some(
    (planDetail, idx) => idx !== index && planDetail.practiceLocationId === location.id
);
                            return !isLocationSelected;
                        });

                    if (availableLocations.length === 0) {
                        return [{ value: "no-data", label: "No data", disabled: true }];
                    }
                    
                    return availableLocations.map(location => ({
                        value: location.id,
                        label: location.name,
                        subtext: location.typeName && location.address ?
                        `${location.typeName} - ${location.address}` :
                        (location.typeName || location.address || "")
                    }));
                });
                
            locationOptions = [...locationOptions, ...cityLocations];
        }
        
        return locationOptions;
    };

    const getDoctorOptions = () => {
    let doctorOptions = [];

    if (!isVisitProfileId && isDoctorsLoading) {
        doctorOptions.push({ value: "loading", label: "Loading...", disabled: true });
        return doctorOptions;
    }
    if (!isDoctorsLoading &&
        ((!isVisitProfileId && doctorsList?.length === 0) ||
            (isVisitProfileId && (!visitProfileData || visitProfileData.visitLocations.length === 0)))) {
            doctorOptions.push({ value: "no-data", label: "No data", disabled: true });
            return doctorOptions;
        }

        if (!isVisitProfileId && !isDoctorsLoading && doctorsList?.length > 0) {
            const isDoctorActive = (doctor) => {
                if (typeof doctor?.active === "boolean") return doctor.active;
                if (typeof doctor?.isActive === "boolean") return doctor.isActive;
                return true;
            };
            const locationDoctors = doctorsList
                .find((location) => location.practiceLocationId === planDetail.practiceLocationId)
                ?.doctors
                ?.filter((doctor) => {
                    const activePlanDate = formValues.employeePlanDates.find(pd => pd.visitProfileId === activeVisitProfileId);
                    const selectedDoctors = activePlanDate?.planDetails
                        .filter((detail, idx) => idx !== index && detail.practiceLocationId === planDetail.practiceLocationId)
                        .map((detail) => detail.doctorId);
                    if (selectedDoctors.includes(doctor.id)) return false;
                    if (isDoctorActive(doctor)) return true;
                    return String(doctor.id) === String(planDetail.doctorId);
                }) || [];
                
            locationDoctors.forEach(doctor => {
                doctorOptions.push({
                    value: doctor.id,
                    label: doctor.name,
                    subtext: doctor.specializationName || ""
                       
                });
            });
        }
        
if (isVisitProfileId) {
    const activePlanDate = formValues.employeePlanDates.find(pd => pd.visitProfileId === activeVisitProfileId);
    const profileDoctors = visitProfileData?.visitLocations
        ?.find((location) => location.practiceLocation.id == planDetail.practiceLocationId)
        ?.practiceLocation
        ?.doctors
        ?.filter((doctor) => {
            const selectedDoctors = activePlanDate?.planDetails
                .filter((detail, idx) => idx !== index && detail.practiceLocationId === planDetail.practiceLocationId)
                .map((detail) => detail.doctorId);
            return !selectedDoctors?.includes(doctor.id);
        }) || [];
                
            profileDoctors.forEach(doctor => {
                doctorOptions.push({
                    value: doctor.id,
                    label: doctor.name,
                    subtext: doctor.specializationName || ""
                       
                });
            });
        }
        
        return doctorOptions;
    };
const getProductOptions = () => {
        if (taskLookupsLoading) return [{ value: 'loading', label: 'Loading...', isDisabled: true }];
        const products = taskLookups?.products;
        if (!Array.isArray(products) || products.length === 0) return [];
        const originalProductIds = originallySelectedProductIdsRef.current || [];
        const isLookupItemActive = (item) => {
            if (typeof item?.active === "boolean") return item.active;
            if (typeof item?.isActive === "boolean") return item.isActive;
            return true;
        };
        return products
            .filter((p) => isLookupItemActive(p) || originalProductIds.includes(String(p.id)))
            .sort((a, b) => a.name.localeCompare(b.name))
            .map(p => ({ value: p.id, label: p.name }));
    };

    const getSubTaskOptions = () => {
        if (taskLookupsLoading) return [{ value: 'loading', label: 'Loading...', isDisabled: true }];
        const subTasks = taskLookups?.subTasks?.result || taskLookups?.subTasks;
        if (!Array.isArray(subTasks) || subTasks.length === 0) return [];
        const originalSubTaskIds = originallySelectedSubTaskIdsRef.current || [];
        const isLookupItemActive = (item) => {
            if (typeof item?.active === "boolean") return item.active;
            if (typeof item?.isActive === "boolean") return item.isActive;
            return true;
        };
        return subTasks
            .filter((s) => isLookupItemActive(s) || originalSubTaskIds.includes(String(s.id)))
            .sort((a, b) => a.name.localeCompare(b.name))
            .map(s => ({ value: s.id, label: s.name }));
    };

    const getPriorityOptions = () => {
        if (taskLookupsLoading) return [{ value: 'loading', label: 'Loading...', isDisabled: true }];
        const priorities = taskLookups?.taskPriorities?.result || taskLookups?.taskPriorities;
        if (!Array.isArray(priorities) || priorities.length === 0) return [];
        const originalPriorityIds = originallySelectedPriorityRef.current || [];
        const isLookupItemActive = (item) => {
            if (typeof item?.active === "boolean") return item.active;
            if (typeof item?.isActive === "boolean") return item.isActive;
            return true;
        };
        return priorities
            .filter((p) => isLookupItemActive(p) || originalPriorityIds.includes(String(p.id)))
            .sort((a, b) => a.name.localeCompare(b.name))
            .map(p => ({ value: p.id, label: p.name }));
    };

    const getAccompaniedByOptions = () => {
        if (taskLookupsLoading) return [{ value: 'loading', label: 'Loading...', isDisabled: true }];
        const reporting = taskLookups?.reporting;
        if (!Array.isArray(reporting) || reporting.length === 0) return [];
        return reporting
            .sort((a, b) => a.firstName.localeCompare(b.firstName))
            .map(e => ({ value: e.id, label: `${e.firstName} ${e.lastName}` }));
    };

    const handleSingleSelectChange = (option, field) => {     
         if (!option || option.value === null || option.value === undefined || option.value === '') {
            switch(field) {
                case 'City':
                    onUpdatePlanDetail(index, { cityId: null, practiceLocationId: null });
                    break;
                case 'Practice Location':
                    onUpdatePlanDetail(index, { practiceLocationId: null, doctorId: null });
                    break;
                case 'Doctor':
                    onUpdatePlanDetail(index, { doctorId: null });
                    break;
                default:
                    break;
            }
            return;
        }   
        switch(field) {
            case 'City':
                handleCitySelect({ target: { value: option.value } });
                break;
            case 'Practice Location':
                handleLocationChange({ target: { value: option.value } });
                break;
            case 'Doctor':
                handleDoctorChange({ target: { value: option.value } });
                break;
            default:
                break;
        }
    };
    return (
    <div className={`add-eventcard ${isOnLeave ? 'disabled-card' : ''}`} style={{ position: 'relative' }}>
        {isDeleteActive && (
            <input type="checkbox" className="event-checkbox" checked={isChecked}  disabled={isOnLeave} onChange={handleCheckbox} />
        )}
            {permissions && permissions.includes('CanAddPlannerTime') && (
                <div className='add-eventcard-section'>
                    <div className='section-label'>
                        <BodySmallMedium text={t("visitTime")} color='#1E293B' />
                    </div>
                    <div className='visit-dropdown-container'>
                        <div className='select-container'>
                            <CustomTimeSelect
                                value={planDetail.startTime || ""}
                                onChange={handleFromTimeSelect}
                                placeholder={t("start")}
                                disabled={isOnLeave} 
                                showClear={true}
                            >
                                <option value="" disabled>
                                    Start
                                </option>
                                {filteredStartTimeOptions().map((time) => (
                                    <option key={time.value} value={time.value}>
                                        {time.label}
                                    </option>
                                ))}
                            </CustomTimeSelect>
                            {errors?.startTime && (<p className='error-single-select-container'>{errors.startTime}</p>)}
                        </div>
                        <img src={minusIcon} />
                        <div className='select-container'>
                            <CustomTimeSelect
                                value={planDetail.endTime || ""}
                                onChange={handleToTimeSelect}
                                placeholder={t("end")}
                                disabled={isOnLeave}
                                showClear={true}
                            >
                                <option value="" disabled>
                                    End
                                </option>
                                {filteredEndTimeOptions().map((time) => (
                                    <option key={time.value} value={time.value}>
                                        {time.label}
                                    </option>
                                ))}
                            </CustomTimeSelect>
                            {errors?.endTime && (<p className='error-single-select-container'>{errors.endTime}</p>)}
                        </div>
                    </div>
                </div>
            )}
            
            {/* Single row for City, Practice Location, and Doctor */}
{(permissions && (permissions.includes('CanAddPlannerCity') || permissions.includes('CanAddPlannerLocation') || permissions.includes('CanAddPlannerDoctor')) || isVisitProfileId) && (
    <>
        <div className='add-eventcard-row'>
            {((permissions && permissions.includes('CanAddPlannerCity')) || isVisitProfileId || (permissions && permissions.includes('CanAddPlannerLocation') && !permissions.includes('CanAddPlannerCity'))) && (
                <div className='field-with-label'>
                    <BodySmallMedium text={t("city")} color='#1E293B' />
                    <div className='select-container'>
<SingleSelect
    options={getCityOptions()}
    value={
        isVisitProfileId && visitProfileData 
            ? visitProfileData.cityId 
            : (!isVisitProfileId && permissions.includes('CanAddPlannerLocation') && !permissions.includes('CanAddPlannerCity'))
                ? (user?.result[0]?.user?.cityId || "")
                : (planDetail.cityId || "")
    }
    onChange={(option) => handleSingleSelectChange(option, 'City')}
    placeholder={t("city")}
    disabled={
        !(permissions.includes('CanAddPlannerCity') && !permissions.includes('CanAddPlannerTime'))
        || planDetail.headOffice
        || isOnLeave
    }
    error={errors?.cityId}
    label=""
    isSearchable
    showClear={true}
/>
                    </div>
                </div>
            )}
            
            {permissions && permissions.includes('CanAddPlannerLocation') && (
                <div className='field-with-label'>
                    <BodySmallMedium text={t("practiceLocation")} color='#1E293B' />
                    <div className='select-container'>
                        <SingleSelect
                            options={getLocationOptions()}
                            value={planDetail.practiceLocationId || ""}
                            onChange={(option) => handleSingleSelectChange(option, 'Practice Location')}
                            placeholder={t("practiceLocation")}
                            error={errors?.practiceLocationId}
                            label=""
                            isSearchable
                            disabled={isOnLeave}
                            showClear={true}
                        />
                    </div>
                </div>
            )}
            
            {permissions && permissions.includes('CanAddPlannerDoctor') && (
                <div className='field-with-label'>
                    <BodySmallMedium text={t("doctor")} color='#1E293B' />
                    <div className='select-container'>
                        <SingleSelect
                            options={getDoctorOptions()}
                            value={planDetail?.doctorId || ""}
                            onChange={(option) => handleSingleSelectChange(option, 'Doctor')}
                            placeholder={t("doctor")}
                            error={errors?.doctorId}
                            label=""
                            isSearchable
                            disabled={isOnLeave}
                            showClear={true}
                        />
                    </div>
                </div>
            )}
        </div>
        
        {permissions && permissions.includes('CanAddPlannerCity') && !permissions.includes('CanAddPlannerTime') && (
            <div className='head-office-row'>
                <input
                    type="checkbox"
                    className='headoffice-checkbox'
                    checked={planDetail.headOffice}
                    onChange={handleHeadOfficeChange}
                    disabled={isOnLeave}
                />
                <BodyMediumMedium text="at head office" color="#6B7280" />
            </div>
        )}
    </>
)}

{/* Products, Sub Tasks, Priority and Accompanied By - only for full planner users */}
{permissions && permissions.includes('CanAddPlannerTime') && (
    <>
        <div className='add-eventcard-row'>
            <div className='field-with-label'>
                <BodySmallMedium text={t("product") || "Products"} color='#1E293B' />
                <MultiSelect
                    isSearchable
                    value={planDetail.products || []}
                    onChange={(vals) => onUpdatePlanDetail(index, { products: vals })}
                    options={getProductOptions()}
                    placeholder={t("product") || "Products"}
                    disabled={isOnLeave}
                    error={errors?.products}
                />
            </div>
            <div className='field-with-label'>
                <BodySmallMedium text={t("subTask") || "Sub Tasks"} color='#1E293B' />
                <MultiSelect
                    isSearchable
                    value={planDetail.subTasks || []}
                    onChange={(vals) => onUpdatePlanDetail(index, { subTasks: vals })}
                    options={getSubTaskOptions()}
                    placeholder={t("subTask") || "Sub Tasks"}
                    disabled={isOnLeave}
                    error={errors?.subTasks}
                />
            </div>
        </div>

        <div className='add-eventcard-row'>
            <div className='field-with-label'>
                <BodySmallMedium text={t("priority") || "Priority"} color='#1E293B' />
                <SingleSelect
                    isSearchable
                    value={planDetail.priority || ""}
                    onChange={(opt) => onUpdatePlanDetail(index, { priority: opt.value })}
                    options={getPriorityOptions()}
                    placeholder={t("priority") || "Priority"}
                    label=""
                    disabled={isOnLeave}
                    error={errors?.priority}
                    showClear={true}
                />
            </div>
            <div className='field-with-label'>
                <BodySmallMedium text={t("accompaniedBy") || "Accompanied By"} color='#1E293B' />
                <MultiSelect
                    isSearchable
                    value={planDetail.accompaniedByIds || []}
                    onChange={(vals) => onUpdatePlanDetail(index, { accompaniedByIds: vals })}
                    options={getAccompaniedByOptions()}
                    placeholder={t("accompaniedBy") || "Accompanied By"}
                    disabled={isOnLeave}
                    error={errors?.accompaniedByIds}
                />
            </div>
        </div>
    </>
)}
        </div>
    );
};

export default AddEventCard;